import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const { distributionTypes: distributionTypesSelectionKey } = selectionsData.keys;

const { autoComplete: autoCompleteInputType } = inputData.types;

const { distributionType: distributionTypeInputName } = inputData.names;

const { type: typeInputLabel } = inputData.labels;

// shared by both distribution forms so the Type field keeps the same slot and styling whichever one renders
const distributionTypeFormData = {
    col: { xs: 12 },
    label: typeInputLabel,
    name: distributionTypeInputName,
    selectionKey: distributionTypesSelectionKey,
    type: autoCompleteInputType,
};

export default distributionTypeFormData;
